import { DESIGN_COPY } from "./designCopy.js";

/** "Open in new tab": the preview's own page, `/prototypes/:id?rev=N`, beside the case file. */
export function OpenInNewTab({ prototypeId, revision }: { prototypeId: string; revision: number }) {
  return (
    <a
      className="cf-design-newtab"
      href={`/prototypes/${encodeURIComponent(prototypeId)}?rev=${revision}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="prototype-open-new-tab"
    >
      {DESIGN_COPY.openInNewTab}
      <svg
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        aria-hidden="true"
      >
        <path d="M7 1.5h3.5V5M10.5 1.5 5.5 6.5M9 7v3.5H1.5V3H5" />
      </svg>
    </a>
  );
}
